export const VERIFY_PAN = 'VERIFY_PAN';
export const VERIFY_PAN_SUCCESS = 'VERIFY_PAN_SUCCESS';

export const SEND_OTP = 'SEND_OTP';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';

export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIF_OTP_SUCCESS = 'VERIF_OTP_SUCCESS';

export const GET_DETAILS_SUCCESS = 'GET_DETAILS_SUCCESS';
export const GET_DETAILS = 'GET_DETAILS';

export const GET_PAYMENT_DETAILS_SUCCESS = 'GET_PAYMENT_DETAILS_SUCCESS';
export const GET_PAYMENT_DETAILS = 'GET_PAYMENT_DETAILS';

export const GET_PAYMENT_OTP_SUCCESS = "GET_PAYMENT_OTP_SUCCESS";
export const GET_PAYMENT_OTP = 'GET_PAYMENT_OTP';

export const GET_OTP_SUCCESS = 'GET_OTP_SUCCESS';
export const GET_OTP = 'GET_OTP';

export const VERIFY_OTP_INVESTOR_SUCCESS = 'VERIFY_OTP_INVESTOR_SUCCESS';
export const VERIFY_OTP_INVESTOR = 'VERIFY_OTP_INVESTOR';

export const VERIFY_OTP_PAYMENT_SUCCESS = "VERIFY_OTP_PAYMENT_SUCCESS";
export const VERIFY_OTP_PAYMENT = "VERIFY_OTP_PAYMENT";

export const GEN_INV_TOKENCOMPANY_SUCCESS = 'GEN_INV_TOKENCOMPANY_SUCCESS';
export const GEN_INV_TOKENCOMPANY = 'GEN_INV_TOKENCOMPANY';

export const GET_APPLICATION_WITH_REF_ID_SUCCESS = 'GET_APPLICATION_WITH_REF_ID_SUCCESS';
export const GET_APPLICATION_WITH_REF_ID = 'GET_APPLICATION_WITH_REF_ID';

export const ESIGN_DOCUMENT_SUCCESS = 'ESIGN_DOCUMENT_SUCCESS';
export const ESIGN_DOCUMENT = 'ESIGN_DOCUMENT';

export const GET_Investment_Details_Aplication_Ref_SUCCESS =
  'GET_Investment_Details_Aplication_Ref_SUCCESS';
export const GET_Investment_Details_Aplication_Ref = 'GET_Investment_Details_Aplication_Ref';

export const GET_RM_LIST_SUCCESS = 'GET_RM_LIST_SUCCESS';
export const GET_RM_LIST = 'GET_RM_LIST';

export const GET_CASH_HISTORY = "GET_CASH_HISTORY";
export const GET_CASH_HISTORY_SUCCESS = "GET_CASH_HISTORY_SUCCESS";

export const GET_ACT_INACT="GET_ACT_INACT"
export const GET_ACT_INACT_SUCCESS="GET_ACT_INACT_SUCCESS"

export const GET_RM_DASHBOARD_METRICS_SUCCESS = 'GET_RM_DASHBOARD_METRICS_SUCCESS';
export const GET_RM_DASHBOARD_METRICS = 'GET_RM_DASHBOARD_METRICS';

export const GET_EXPORT_AUM_SUCCESS = 'GET_EXPORT_AUM_SUCCESS';
export const GET_EXPORT_AUM = 'GET_EXPORT_AUM';

export const GET_RM_REDIRECTION_LINK_SUCCESS = 'GET_RM_REDIRECTION_LINK_SUCCESS';
export const GET_RM_REDIRECTION_LINK = 'GET_RM_REDIRECTION_LINK';

export const GET_ASSET_CLASSES = 'GET_ASSET_CLASSES';
export const GET_ASSET_CLASSES_SUCCESS = 'GET_ASSET_CLASSES_SUCCESS';
export const GET_ASSET_CLASSES_FAILED = 'GET_ASSET_CLASSES_FAILED';
export const GET_SUB_ASSET_CLASSES = 'GET_SUB_ASSET_CLASSES';
export const GET_SUB_ASSET_CLASSES_SUCCESS = 'GET_SUB_ASSET_CLASSES_SUCCESS';
export const GET_SUB_ASSET_CLASSES_FAILED = 'GET_SUB_ASSET_CLASSES_FAILED';
export const GET_SCHEME_LIST = 'GET_SCHEME_LIST';
export const GET_SCHEME_LIST_SUCCESS = 'GET_SCHEME_LIST_SUCCESS';
export const GET_SCHEME_LIST_FAILED = 'GET_SCHEME_LIST_FAILED';
export const GET_SCHEME_DETAILS = 'GET_SCHEME_DETAILS';
export const GET_SCHEME_DETAILS_SUCCESS = 'GET_SCHEME_DETAILS_SUCCESS';
export const GET_SCHEME_DETAILS_FAILED = 'GET_SCHEME_DETAILS_FAILED';
export const GET_CATEGORY_AVERAGE = 'GET_CATEGORY_AVERAGE';
export const GET_CATEGORY_AVERAGE_SUCCESS = 'GET_CATEGORY_AVERAGE_SUCCESS';
export const GET_CATEGORY_AVERAGE_FAILED = 'GET_CATEGORY_AVERAGE_FAILED';
export const GET_SCHEME_NAV = 'GET_SCHEME_NAV';
export const GET_SCHEME_NAV_SUCCESS = 'GET_SCHEME_NAV_SUCCESS';
export const GET_SCHEME_NAV_FAILED = 'GET_SCHEME_NAV_FAILED';
export const POST_RECOMMENDED_SCHEMES = 'POST_RECOMMENDED_SCHEMES';
export const POST_RECOMMENDED_SCHEMES_SUCCESS = 'POST_RECOMMENDED_SCHEMES_SUCCESS';
export const POST_RECOMMENDED_SCHEMES_FAILED = 'POST_RECOMMENDED_SCHEMES_FAILED';
export const DELETE_RECOMMENDED_SCHEMES = 'DLETE_RECOMMENDED_SCHEMES';
export const DELETE_RECOMMENDED_SCHEMES_SUCCESS = 'DELETE_RECOMMENDED_SCHEMES_SUCCESS';
export const DELETE_RECOMMENDED_SCHEMES_FAILED = 'DELETE_RECOMMENDED_SCHEMES_FAILED';
export const GET_RECOMMENDATION_VALIDATION = 'GET_RECOMMENDATION_VALIDATION';
export const GET_RECOMMENDATION_VALIDATION_SUCCESS = 'GET_RECOMMENDATION_VALIDATION_SUCCESS';
export const GET_RECOMMENDATION_VALIDATION_FAILED = 'GET_RECOMMENDATION_VALIDATION_FAILED';
export const GET_RECOMMENDED_SCHEMES = 'GET_RECOMMENDED_SCHEMES';
export const GET_RECOMMENDED_SCHEMES_SUCCESS = 'GET_RECOMMENDED_SCHEMES_SUCCESS';
export const GET_RECOMMENDED_SCHEMES_FAILED = 'GET_RECOMMENDED_SCHEMES_FAILED';
export const GET_ACCOUNT_TYPE = 'GET_ACCOUNT_TYPE';
export const GET_ACCOUNT_TYPE_SUCCESS = 'GET_ACCOUNT_TYPE_SUCCESS';
export const GET_ACCOUNT_TYPE_FAILED = 'GET_ACCOUNT_TYPE_FAILED';
export const GET_PORTFOLIO_SUCCESS = 'GET_PORTFOLIO_SUCCESS'
export const GET_PORTFOLIO_FAILED = 'GET_PORTFOLIO_FAILED'
export const GET_SWP_SUCCESS = 'GET_SWP_SUCCESS'
export const GET_SWP_FAILED = 'GET_SWP_FAILED'
export const GET_SCHEMES_SUCCESS = 'GET_SCHEMES_SUCCESS'
export const GET_SCHEMES_FAILED = 'GET_SCHEMES_FAILED'

export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS'
export const GET_ACCOUNT_FAILED = 'GET_ACCOUNT_FAILED'


export const GET_DISTRIBUTORS_LIST_SUCCESS = 'GET_DISTRIBUTORS_LIST_SUCCESS';
export const GET_DISTRIBUTORS_LIST = 'GET_DISTRIBUTORS_LIST';

export const ADD_RMS_LIST_SUCCESS = 'ADD_RMS_LIST_SUCCESS';
export const ADD_RMS_LIST = 'ADD_RMS_LIST';

export const ADD_DISTRIBUTOR_SUCCESS = 'ADD_DISTRIBUTOR_SUCCESS';
export const ADD_DISTRIBUTOR = 'ADD_DISTRIBUTOR';

export const GET_SUBDISTRIBUTOR_SUCCESS = 'GET_SUBDISTRIBUTOR_SUCCESS';
export const GET_SUBDISTRIBUTOR = 'GET_SUBDISTRIBUTOR';

export const ENABLE_POA_SUCCESS = 'ENABLE_POA_SUCCESS';
export const ENABLE_POA = 'ENABLE_POA';

export const EDIT_DISTRIBUTOR_SUCCESS = 'EDIT_DISTRIBUTOR_SUCCESS';
export const EDIT_DISTRIBUTOR = 'EDIT_DISTRIBUTOR';

export const EDIT_RM_SUCCESS = 'EDIT_RM_SUCCESS';
export const EDIT_RM = 'EDIT_RM';

export const GET_Countries_SUCCESS = 'GET_Countries_SUCCESS';
export const GET_Countries = 'GET_Countries';

export const APPLICABLE_FOR_POA_SUCCESS = 'APPLICABLE_FOR_POA_SUCCESS';
export const APPLICABLE_FOR_POA = 'APPLICABLE_FOR_POA';

export const GET_TRUSTEE_LIST_SUCCESS = 'GET_TRUSTEE_LIST_SUCCESS';
export const GET_TRUSTEE_LIST = 'GET_TRUSTEE_LIST';

export const ADD_TRUSTEE_SUCCESS = 'ADD_TRUSTEE_SUCCESS';
export const ADD_TRUSTEE = 'ADD_TRUSTEE';

export const UPDATE_TRUSTEE_SUCCESS = 'UPDATE_TRUSTEE_SUCCESS';
export const UPDATE_TRUSTEE = 'UPDATE_TRUSTEE';

export const GET_FUND_MANAGERS_LIST_SUCCESS = 'GET_FUND_MANAGERS_LIST_SUCCESS';
export const GET_FUND_MANAGERS_LIST = 'GET_FUND_MANAGERS_LIST';

export const GET_AIF_APPROVER_LIST_SUCCESS = 'GET_AIF_APPROVER_LIST_SUCCESS';
export const GET_AIF_APPROVER_LIST = 'GET_AIF_APPROVER_LIST';

export const ADD_DISTRIBUTOR_RM_SUCCESS = 'ADD_DISTRIBUTOR_RM_SUCCESS';
export const ADD_DISTRIBUTOR_RM = 'ADD_DISTRIBUTOR_RM';

export const ADD_FUND_MANAGER_SUCCESS = 'ADD_FUND_MANAGER_SUCCESS';
export const ADD_FUND_MANAGER = 'ADD_FUND_MANAGER';

export const GET_AUTHORISEDSIGNATORY_LIST_SUCCESS = 'GET_AUTHORISEDSIGNATORY_LIST_SUCCESS';
export const GET_AUTHORISEDSIGNATORY_LIST = 'GET_AUTHORISEDSIGNATORY_LIST';

export const ADD_AUTHORISEDSIGNATORY_SUCCESS = 'ADD_AUTHORISEDSIGNATORY_SUCCESS';
export const ADD_AUTHORISEDSIGNATORY = 'ADD_AUTHORISEDSIGNATORY';

export const UPDATE_AUTHORISEDSIGNATORY_SUCCESS = 'UPDATE_AUTHORISEDSIGNATORY_SUCCESS';
export const UPDATE_AUTHORISEDSIGNATORY = 'UPDATE_AUTHORISEDSIGNATORY';

export const UPDATE_FUND_MANAGER_SUCCESS = 'UPDATE_FUND_MANAGER_SUCCESS';
export const UPDATE_FUND_MANAGER = 'UPDATE_FUND_MANAGER';

export const UPDATE_DISTRIBUTOR_RM_SUCCESS = 'UPDATE_DISTRIBUTOR_RM_SUCCESS';
export const UPDATE_DISTRIBUTOR_RM = 'UPDATE_DISTRIBUTOR_RM';

export const GET_POAAPPROVER_LIST_SUCCESS = 'GET_POAAPPROVER_LIST_SUCCESS';
export const GET_POAAPPROVER_LIST = 'GET_POAAPPROVER_LIST';

export const ADD_POAAPPROVER_SUCCESS = 'ADD_POAAPPROVER_SUCCESS';
export const ADD_POAAPPROVER = 'ADD_POAAPPROVER';

export const UPDATE_POAAPPROVER_SUCCESS = 'UPDATE_POAAPPROVER_SUCCESS';
export const UPDATE_POAAPPROVER = 'UPDATE_POAAPPROVER';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL = 'SEND_EMAIL';

export const PHYSICAL_ONBOARDING_SUCCESS = 'PHYSICAL_ONBOARDING_SUCCESS';
export const PHYSICAL_ONBOARDING = 'PHYSICAL_ONBOARDING';

export const ONBOARDING_SUMMARY_REPORT = 'ONBOARDING_SUMMARY_REPORT';
export const ONBOARDING_SUMMARY_REPORT_SUCCESS = 'ONBOARDING_SUMMARY_REPORT_SUCCESS';

export const ONBOARDING_DETAIL_REPORT = 'ONBOARDING_DETAIL_REPORT';
export const ONBOARDING_DETAIL_REPORT_SUCCESS = 'ONBOARDING_DETAIL_REPORT_SUCCESS';

export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS';
export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT = 'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT';

export const ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_SUMMARY_REPORT_DOWNLOAD = 'ONBOARDING_SUMMARY_REPORT_DOWNLOAD';

export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_DETAIL_REPORT_DOWNLOAD = 'ONBOARDING_DETAIL_REPORT_DOWNLOAD';

export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS =
  'ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS';
export const ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL = 'ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL';

ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS;

export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS';
export const DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD =
  'DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD';

export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS';
export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT = 'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT';

export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS';
export const DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD =
  'DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD';

export const ACKNOWLEDGE_AML_CHECK_SUCCESS = 'ACKNOWLEDGE_AML_CHECK_SUCCESS';
export const ACKNOWLEDGE_AML_CHECK = 'ACKNOWLEDGE_AML_CHECK';

export const GET_AIFAPPROVERACCESS_SUCCESS = 'GET_AIFAPPROVERACCESS_SUCCESS';
export const GET_AIFAPPROVERACCESS = 'GET_AIFAPPROVERACCESS';

export const GET_RMBYID_SUCCESS = 'GET_RMBYID_SUCCESS';
export const GET_RMBYID = 'GET_RMBYID';

export const GET_RMBYIWAPP_SUCCESS = 'GET_RMBYIWAPP_SUCCESS';
export const GET_RMBYIWAPP = 'GET_RMBYIWAPP';

export const GET_DISTRIBUTORRMBYID_SUCCESS = 'GET_DISTRIBUTORRMBYID_SUCCESS';
export const GET_DISTRIBUTORRMBYID = 'GET_DISTRIBUTORRMBYID_SUCCESS';

export const GET_AUTHORISEDSIGNATORYBYID_SUCCESS = 'GET_AUTHORISEDSIGNATORYBYID_SUCCESS';
export const GET_AUTHORISEDSIGNATORYBYID = 'GET_AUTHORISEDSIGNATORYBYID';

export const GET_POAAPPROVERBYID_SUCCESS = 'GET_POAAPPROVERBYID_SUCCESS';
export const GET_POAAPPROVERBYID = 'GET_POAAPPROVERBYID';

export const GET_TRUSTEEBYID_SUCCESS = 'GET_TRUSTEEBYID_SUCCESS';
export const GET_TRUSTEEBYID = 'GET_TRUSTEEBYID';

export const GET_AIF_APPROVERBYID_SUCCESS = 'GET_AIF_APPROVERBYID_SUCCESS';
export const GET_AIF_APPROVERBYID = 'GET_AIF_APPROVERBYID';

export const GET_FUND_MANAGERSBYID_SUCCESS = 'GET_FUND_MANAGERSBYID_SUCCESS';
export const GET_FUND_MANAGERSBYID = 'GET_FUND_MANAGERSBYID';

export const GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS = 'GET_DISTRIBUTORSOFRM_BY_RMID_SUCCESS';
export const GET_DISTRIBUTORSOFRM_BY_RMID = 'GET_DISTRIBUTORSOFRM_BY_RMID';

export const GET_TRUSTEEACCESS_SUCCESS = 'GET_TRUSTEEACCESS_SUCCESS';
export const GET_TRUSTEEACCESS = 'GET_TRUSTEEACCESS';

export const GET_IMACCESS_SUCCESS = 'GET_IMACCESS_SUCCESS';
export const GET_IMACCESS = 'GET_IMACCESS';

export const GET_AMCADMINACCESS_SUCCESS = 'GET_AMCADMINACCESS_SUCCESS';
export const GET_AMCADMINACCESS = 'GET_AMCADMINACCESS';

export const GET_AMCADMIN_LIST_SUCCESS = 'GET_AMCADMIN_LIST_SUCCESS';
export const GET_AMCADMIN_LIST = 'GET_AMCADMIN_LIST';

export const GET_AMCADMINBYID_SUCCESS = 'GET_AMCADMINBYID_SUCCESS';
export const GET_AMCADMINBYID = 'GET_AMCADMINBYID';

export const ADD_AMCADMIN_SUCCESS = 'ADD_AMCADMIN_SUCCESS';
export const ADD_AMCADMIN = 'ADD_AMCADMIN';

export const UPDATE_AMCADMIN_SUCCESS = 'UPDATE_AMCADMIN_SUCCESS';
export const UPDATE_AMCADMIN = 'UPDATE_AMCADMIN';

export const SEND_CONSENTEMAIL_SUCCESS = 'SEND_CONSENTEMAIL_SUCCESS';
export const SEND_CONSENTEMAIL = 'SEND_CONSENTEMAIL';

export const SEND_CONSENTEMAIL_APPROVE_SUCCESS = 'SEND_CONSENTEMAIL_APPROVE_SUCCESS';
export const SEND_CONSENTEMAIL_APPROVE = 'SEND_CONSENTEMAIL_APPROVE';

export const SEND_CONSENTEMAIL_REJECT_SUCCESS = 'SEND_CONSENTEMAIL_REJECT_SUCCESS';
export const SEND_CONSENTEMAIL_REJECT = 'SEND_CONSENTEMAIL_REJECT';

export const DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS =
  'DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS';
export const DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT =
  'DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT';

export const ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS =
  'ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS';
export const ONBOARDING_COMPLETED_REPORT_DOWNLOAD = 'ONBOARDING_COMPLETED_REPORT_DOWNLOAD';

export const GET_APPLICATION_DOWNLOAD_SUCCESS = 'GET_APPLICATION_DOWNLOAD_SUCCESS';
export const GET_APPLICATION_DOWNLOAD = 'GET_APPLICATION_DOWNLOAD';

export const EXPORT_APPLICATIONS_LIST_SUCCESS = 'EXPORT_APPLICATIONS_LIST_SUCCESS';
export const EXPORT_APPLICATIONS_LIST = 'EXPORT_APPLICATIONS_LIST';

export const SEND_BSE_CONSENT_SUCCESS = 'SEND_BSE_CONSENT_SUCCESS';
export const SEND_BSE_CONSENT = 'SEND_BSE_CONSENT';

// for Id
export const SET_IWAPP_RMID = 'SET_IWAPP_RMID';
export const SET_INVESTOR_CLIENTID = 'SET_INVESTOR_CLIENTID';
export const SET_APPLICANT_ID = 'SET_APPLICANT_ID';
export const SET_APPLICATION_TYPE = 'SET_APPLICATION_TYPE';

export const SET_INTERFACE_CODE = 'SET_INTERFACE_CODE';
export const SET_PORTFOLIO = 'SET_PORTFOLIO';
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID';
export const SET_IS_BSE_ENABLED = 'SET_IS_BSE_ENABLED';

export const SET_APPLICATION_ID_FOR_NOMINEECHECK='SET_APPLICATION_ID_FOR_NOMINEECHECK'

export const GET_RM_HIERARCHY_SUCCESS = 'GET_RM_HIERARCHY_SUCCESS'
export const GET_RM_HIERARCHY = 'GET_RM_HIERARCHY'

export const GET_REPORTS_INVESTOR_LIST_SUCCESS = 'GET_REPORTS_INVESTOR_LIST_SUCCESS'
export const GET_REPORTS_INVESTOR_LIST = 'GET_REPORTS_INVESTOR_LIST'

export const GET_REPORTS_DETAILED_HOLDINGS_SUCCESS = "GET_REPORTS_DETAILED_HOLDINGS_SUCCESS"
export const GET_REPORTS_DETAILED_HOLDINGS = "GET_REPORTS_DETAILED_HOLDINGS"

export const GET_REPORTS_TRANSACTION_HISTORY_SUCCESS = "GET_REPORTS_TRANSACTION_HISTORY_SUCCESS"
export const GET_REPORTS_TRANSACTION_HISTORY = "GET_REPORTS_TRANSACTION_HISTORY"

export const GET_MF_TRANSACTION_WISE_REPORT_SUCCESS = "GET_MF_TRANSACTION_WISE_REPORT_SUCCESS"
export const GET_MF_TRANSACTION_WISE_REPORT = "GET_MF_TRANSACTION_WISE_REPORT"

export const GET_CLIENT_STATEMENT_SUCCESS = "GET_CLIENT_STATEMENT_SUCCESS"
export const GET_CLIENT_STATEMENT = "GET_CLIENT_STATEMENT"

export const REN_GET_CLIENT_STATEMENT_SUCCESS = "GET_CLIENT_STATEMENT_SUCCESS"
export const REN_GET_CLIENT_STATEMENT = "GET_CLIENT_STATEMENT"

export const HOLDING_REPORT_SUCCESS = "HOLDING_REPORT_SUCCESS"
export const HOLDING_REPORT = "HOLDING_REPORT"

export const PORTFOLIO_XIRR_REPORT_SUCCESS = "PORTFOLIO_XIRR_REPORT_SUCCESS"
export const PORTFOLIO_XIRR_REPORT = "PORTFOLIO_XIRR_REPORT"

export const T1_REPORT_SUCCESS = "T1_REPORT_SUCCESS"
export const T1_REPORT = "T1_REPORT"

export const CAPITAL_GAIN_STATEMENT_SUCCESS = "CAPITAL_GAIN_STATEMENT_SUCCESS"
export const CAPITAL_GAIN_STATEMENT = "CAPITAL_GAIN_STATEMENT"

export const CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS = "CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS"
export const CAPITAL_GAIN_STATEMENT_INVESTOR = "CAPITAL_GAIN_STATEMENT_INVESTOR"
export const GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS = "GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS"
export const GET_CUSTOMER_TRANSACTION_HISTORY_REPORT = "GET_CUSTOMER_TRANSACTION_HISTORY_REPORT"

export const GET_APPLICATION_TYPES_SUCCESS = 'GET_APPLICATION_TYPES_SUCCESS';
export const GET_APPLICATION_TYPES = 'GET_APPLICATION_TYPES';


//Digilocker KYC constants

export const GET_DIGILOCKER_SUCCESS = 'GET_DIGILOCKER_SUCCESS';
export const GET_DIGILOCKER = 'GET_DIGILOCKER';

export const GET_DIGILOCKER_DATA_SUCCESS = 'GET_DIGILOCKER_DATA_SUCCESS';
export const GET_DIGILOCKER_DATA = 'GET_DIGILOCKER_DATA';
// aadhar xml 
export const GET_AADHAR_XML_SUCCESS = 'GET_AADHAR_XML_SUCCESS';
export const GET_AADHAR_XML = 'GET_AADHAR_XML';

export const SET_IS_PORTFOLIO_AVAILABLE = "SET_IS_PORTFOLIO_AVAILABLE"

export const GET_MASTER_SUCCESS = 'GET_MASTER_SUCCESS';
export const GET_MASTER = 'GET_MASTER';

export const GET_CKYC_CONSENT_OTP_SUCCESS = 'GET_CKYC_CONSENT_OTP_SUCCESS';
export const GET_CKYC_CONSENT_OTP = 'GET_CKYC_CONSENT_OTP';

export const GET_CKYC_RECORD_SUCCESS = 'GET_CKYC_RECORD_SUCCESS';
export const GET_CKYC_RECORD = 'GET_CKYC_RECORD';

export const CKYC_DATA_VALIDATION_SUCCESS = 'CKYC_DATA_VALIDATION_SUCCESS';
export const CKYC_DATA_VALIDATION = 'CKYC_DATA_VALIDATION';

export const CREATE_CLIENT_STATEMENT_SUCCESS = "CREATE_CLIENT_STATEMENT_SUCCESS";
export const CREATE_CLIENT_STATEMENT = "CREATE_CLIENT_STATEMENT"

export const GET_CLIENT_STATEMENT_LIST_SUCCESS = "GET_CLIENT_STATEMENT_LIST_SUCCESS"
export const GET_CLIENT_STATEMENT_LIST = "GET_CLIENT_STATEMENT_LIST"

export const UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS = "UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS"
export const UPDATE_CLIENT_STATEMENT_STATUS = "UPDATE_CLIENT_STATEMENT_STATUS"

export const CLIENT_STATEMENT_DOWNLOAD_SUCCESS = "CLIENT_STATEMENT_DOWNLOAD_SUCCESS"
export const CLIENT_STATEMENT_DOWNLOAD = "CLIENT_STATEMENT_DOWNLOAD"

export const DIY_ESIGN_SUCCESS = "DIY_ESIGN_SUCCESS"
export const DIY_ESIGN = "DIY_ESIGN"

export const SET_APPLICANT_DETAILS = "SET_APPLICANT_DETAILS"
export const GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS = "GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS"
export const GET_REPORTS_ANALYST_INVESTOR_LIST = "GET_REPORTS_ANALYST_INVESTOR_LIST"

export const SET_FAMILY_DETAILS = "SET_FAMILY_DETAILS"

export const SET_SHOW_MFC_REPORT = "SET_SHOW_MFC_REPORT"

export const SET_BSE_CLIENT_ACTIVATION_STATUS = "SET_BSE_CLIENT_ACTIVATION_STATUS"

export const GET_TRIGGER_ELOG_SUCCESS = "GET_TRIGGER_ELOG_SUCCESS"
export const GET_TRIGGER_ELOG = "GET_TRIGGER_ELOG"
export const SET_PAN_NUMBER = "SET_PAN_NUMBER"

export const GET_TAGGED_RM_LIST_SUCCESS = "GET_TAGGED_RM_LIST_SUCCESS"
export const GET_TAGGED_RM_LIST = "GET_TAGGED_RM_LIST"

export const GET_NAVBAR_NOTIFICATIONS_SUCCESS = "GET_NAVBAR_NOTIFICATIONS_SUCCESS"
export const GET_NAVBAR_NOTIFICATIONS = "GET_NAVBAR_NOTIFICATIONS"
export const SET_NAVBAR_NOTIFICATIONS = "SET_NAVBAR_NOTIFICATIONS"

export const NON_KYC_VERIFY_PAN_SUCCESS = "NON_KYC_VERIFY_PAN_SUCCESS"
export const NON_KYC_VERIFY_PAN = "NON_KYC_VERIFY_PAN"

export const SUBMIT_NON_KYC_APPLICATION_TO_BSE_SUCCESS = "SUBMIT_NON_KYC_APPLICATION_TO_BSE_SUCCESS"
export const SUBMIT_NON_KYC_APPLICATION_TO_BSE = "SUBMIT_NON_KYC_APPLICATION_TO_BSE"

export const GET_DEEMED_OVD_SUCCESS = "GET_DEEMED_OVD_SUCCESS"
export const GET_DEEMED_OVD = "GET_DEEMED_OVD"

export const GET_COPYLINK_SUCCESS="GET_COPYLINK_SUCCESS"
export const COPY_LINK="COPY_LINK"

export const RESEND_LINK_SUCCESS="RESEND_LINK_SUCCESS"
export const RESEND_LINK="RESEND_LINK"

export interface CreateClientStatementRequestBody {
  clientCode: string;
  rmId: string;
  // startDate: string;
  endDate: string;
  accountType: string;
  consolidatedLevel?: string;
  custFilterValue?: string;
  heldAway: string;
}

export interface CreateClientStatementResponseBody {
  isSuccess: boolean;
  message: string;
  jobId: string;
}

export interface GetClientStatementListRequestBody {
  rmId: string;
  sort: string;
  order: string;
  currentPage: number;
  rowsPerPage: number;
  clientCode?: string;
}

export interface ClientStatementReportsList {
  id: string;
  clientCode: string;
  jobId: string;
  status: string;
  rmId: string;
  portfolioId: string | null;
  clientName: string;
  remarks: string | null;
  createdAt: string;
  updatedAt: string;
  reportDate: string;
  accountType: string;
  consolidatedLevel: string;
  custFilterValue: string;
}

export interface GetClientStatementListResponseBody {
  reports: Array<ClientStatementReportsList>;
  count: number;
}

export interface UpdateClientStatementStatusRequestBody {
  rmId: string;
  clientCode?: string;
}

export interface UpdateClientStatementStatusResponseBody {
  reports: Array<ClientStatementReportsList>;
  count: number;
}

export interface ClientStatementDownloadRequestBody {
  jobId: string;
}
